import { Routes } from '@angular/router';
import { titleResolver } from '../shared/Utils/resolvers/title.resolver';

export const landingRoutes: Routes = [
  {
    path: '',
    loadComponent: async () =>
      (await import('./pages/landing/landing-page.component'))
        .LandingPageComponent,
  },
];

export const publicRoutes: Routes = [
  {
    path: '',
    data: {
      titleTranslationKey: 'publicEvent.title',
    },
    resolve: {
      titleResolver,
    },
    loadComponent: async () =>
      (await import('./pages/public-event-page/public-event-page.component'))
        .PublicEventPageComponent,
  },
];

export const termsRoutes: Routes = [
  {
    path: '',
    data: {
      titleTranslationKey: 'terms.title',
    },
    resolve: {
      titleResolver,
    },
    loadComponent: async () =>
      (await import('./pages/terms-conditions-page/terms-conditions-page.component'))
        .TermsConditionsPageComponent,
  },
];

